import React from 'react';
import Button from 'components/Button';
import { Icon } from 'antd';
import PropTypes from 'prop-types';
import OwlCarousel from 'react-owl-carousel';
import { formatMoney, isMobile } from 'common/helpers';
import RoomInfo from './RoomInfo';
import { Room as S } from './styles';

class Room extends React.Component {
  next = () => this.slider.next();

  prev = () => this.slider.prev();

  renderTitle = (room) => {
    return (
      <div className="caption top">
        <h4>
          <div>{room.name}</div>
          <div>THB {formatMoney(room.notes, 0)} (~${formatMoney(room.price, 0)}+)<span className="asterisk">*</span></div>
        </h4>
        <h5>
          <strong className="warning">{room.quantities_remaining > 0 ? 'Running Low!' : 'SOLD OUT!'}</strong>
          <strike>~${formatMoney(room.strike_through_price, 0)}</strike>
        </h5>
      </div>
    );
  }

  renderDetails = (room) => {
    return (
      <div className="details">
        <h3>{room.desc}</h3>
        <div>
          <p>{room.listOne}</p>
          <p>{room.listTwo}</p>
        </div>
      </div>
    );
  }

  renderInfo = (room) => {
    const disabled = room.quantities_remaining <= 0;
    return (
      <div className="caption">
        {!isMobile() ? this.renderTitle(room) : null}
        {!isMobile() ? this.renderDetails(room) : <RoomInfo room={room} />}
        <a href={this.props.deeplink} target="blank">
          <Button size="1.5em" padding="10px 15px" className="reserve" style={{ textTransform: 'none' }} data-hotel-name={`Centara Grand - ${room.name}`} disabled={disabled}>{room.quantities_remaining > 0 ? 'RESERVE NOW' : 'SOLD OUT'}</Button>
        </a>
      </div>
    );
  }
  render() {
    const { room } = this.props;
    return (
      <S.Wrapper className={room.class}>
        {isMobile() ? this.renderTitle(room) : null}
        <div style={{ backgroundImage: `url(${room.image})` }} className="img">
          <div className="save">Save {room.savings}%</div>
          <OwlCarousel
            items={1}
            ref={(ref) => { this.slider = ref; }}
            loop={true}
            autoplay={true}
            dots={true}
            dotsEach={true}
          >
            {room.sliders.map((img) => (
              <div key={img.toString()}>
                <img src={img} alt="hotels" />
              </div>
            ))}
          </OwlCarousel>
          <S.Control left onClick={this.prev}><Icon type="arrow-left" /></S.Control>
          <S.Control right onClick={this.next}><Icon type="arrow-right" /></S.Control>
        </div>
        {room.class ? null : this.renderInfo(room)}
      </S.Wrapper>
    );
  }
}

Room.propTypes = {
  room: PropTypes.object.isRequired,
  deeplink: PropTypes.string.isRequired,
};

export default Room;



// WEBPACK FOOTER //
// ./src/containers/Hotel/Room.js